import React from "react";
import { useMainButton } from "@/lib/hooks";
import { isInsideTelegram } from "@/lib/telegram";

/**
 * The page's primary action. Inside Telegram it drives the native
 * MainButton (the familiar bottom button). In a plain browser tab — during
 * testing, or if someone opens the link outside Telegram — it renders a
 * regular button instead, so every flow stays usable everywhere.
 */
export function MainAction({
  text,
  onClick,
  disabled,
  loading,
  hidden,
  caption,
  glass,
}: {
  /** Shown next to the button in the browser bar (e.g. the price). */
  caption?: React.ReactNode;
  text: string;
  onClick: () => void;
  disabled?: boolean;
  loading?: boolean;
  hidden?: boolean;
  /**
   * Draw our own floating "glass" bar (price + button) everywhere, including
   * inside Telegram, instead of the native MainButton. Used on the product page.
   */
  glass?: boolean;
}) {
  useMainButton(text, onClick, { disabled, loading, hidden: hidden || glass });

  if (hidden || (!glass && isInsideTelegram())) return null;

  // Outside Telegram we draw the bar ourselves: a floating "glass" panel.
  return (
    <>
      {/* reserves room so the floating bar never covers the end of the page */}
      <div className="main-action-spacer" aria-hidden="true" />
    <div className="main-action-bar">
      {caption && <div className="main-action-bar__caption">{caption}</div>}
      <button className="btn btn--primary main-action-fallback" onClick={onClick} disabled={disabled || loading}>
        {loading ? "…" : text}
      </button>
    </div>
    </>
  );
}
